import { AbstractControl, AsyncValidatorFn, ValidationErrors } from "@angular/forms";
import { Observable, of } from "rxjs";
import { delay, map, take, tap } from "rxjs/operators";
import { FacadeService } from "src/app/shared/service-facade/facade.service";

export class ProductEligibilityValidator {
  static create(facade: FacadeService): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return facade.currentProductEligibility$.pipe(
        take(1),
        map(response => {
          if (!response) { return null }

          const ineligibleProducts = response.products?.filter(product => !product.isEligible);

          return ineligibleProducts!.length > 0 ? { productErrors: ineligibleProducts! } : null;
        })
      );
    }
  }
}
